<template>
  <div>
    <div class="relative flex justify-center w-full pt-12 pb-16 overflow-hidden md:pt-6 md:items-center hero header-height-top-space viewport-gutter">
      <div class="w-full md:my-auto">
        <div class="container w-full">
          <div class="w-full max-w-68 md:max-w-xl xl:max-w-4xl">
            <h1 class="text-2.5xl leading-tight font-bold pb-5 md:text-4xl xl:pb-7 uppercase text-sn-secondary">
              {{ tr('pages.sales.landing.hero.title') }}
            </h1>
          </div>
          <div class="md:max-w-xl xl:max-w-3xl">
            <p class="text-lg font-normal md:text-xl xl:text-2xl">
              {{ tr('pages.sales.landing.hero.subtitle') }}
            </p>
          </div>

          <div class="pt-7 xl:pt-14">
            <div class="max-w-68">
              <Button
                id="hero-action-button"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
                variant="primary"
                full-width
              >
                {{ tr('pages.sales.landing.hero.button') }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative -mt-12 pb-14 viewport-gutter xl:pb-20">
      <div class="container">
        <div class="flex flex-col px-4 py-5 bg-white rounded-md shadow-10 md:flex-row md:py-6 xl:px-10 xl:pb-8 xl:pt-9">
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mr-3 -mt-1">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M25.26 8.952v1.8h-3.6v-1.8h-7.2v1.8h-3.6v-1.8h-2.7v19.8h19.8v-19.8h-2.7zm.9 18H9.96v-12.6h16.2v12.6z" fill="#05164D"/><path d="M24.36 8.052h-1.8v1.8h1.8v-1.8zM13.56 8.052h-1.8v1.8h1.8v-1.8zM15.336 19.872L14.172 21.3l3.336 2.712 4.32-5.592-1.464-1.128-3.156 4.092-1.872-1.512z" fill="#05164D"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-1.5xl">
                {{ tr('pages.sales.landing.benefit.one.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.one.description') }}
              </p>
            </div>
          </div>
          <div class="flex mb-5 md:w-1/3 md:mb-0 md:mr-6 xl:mr-10">
            <div class="flex-shrink-0 mt-1 mr-3">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 .543c1.617 0 3.14.305 4.57.914a12.315 12.315 0 013.692 2.531 12.315 12.315 0 012.531 3.692c.61 1.43.914 2.953.914 4.57 0 1.617-.305 3.14-.914 4.57a12.315 12.315 0 01-2.531 3.692 12.315 12.315 0 01-3.692 2.531c-1.43.61-2.953.914-4.57.914-1.617 0-3.14-.305-4.57-.914a12.315 12.315 0 01-3.692-2.531 12.315 12.315 0 01-2.531-3.692 11.533 11.533 0 01-.914-4.57c0-1.617.305-3.14.914-4.57a12.315 12.315 0 012.531-3.692A12.315 12.315 0 017.43 1.457C8.86.847 10.383.543 12 .543zM8.203 13.691c.024-.023.035-.046.035-.07v-.07c0-.024-.011-.047-.035-.07v-.07l-1.336-1.442c-.023-.024-.058-.035-.105-.035-.024-.024-.047-.036-.07-.036H2.93a.238.238 0 01-.176-.07.391.391 0 01-.035-.176v-.035-.035l.914-2.46a.41.41 0 01.07-.106c.047-.047.094-.07.14-.07h.036c.047 0 .082.023.105.07a.409.409 0 01.106.07l.351.773v.036a.41.41 0 01.07.105.313.313 0 00.141.035h.387a.239.239 0 00.246-.246v-.035H5.25l-.176-1.055v-.035c0-.07.012-.129.035-.176a.238.238 0 01.176-.07h.844a.312.312 0 00.14-.035c.047-.047.07-.094.07-.14l.774-2.18v-.036c.024-.023.035-.047.035-.07 0-.023-.011-.047-.035-.07l-.035-.07-.387-.352c0-.024-.023-.035-.07-.035-.023-.024-.047-.035-.07-.035-.047 0-.082.011-.106.035-.023 0-.047.011-.07.035L5.25 6.555l-.07.07h-.106a.312.312 0 01-.14-.035.409.409 0 00-.07-.106l-.247-.527-.246-.035a10.365 10.365 0 00-1.687 2.883 9.758 9.758 0 00-.598 3.41c0 1.242.21 2.414.633 3.515a9.994 9.994 0 001.758 2.918l.07.07h.105a.313.313 0 00.141-.034c.047-.024.07-.07.07-.141l.176-.598c.024-.023.035-.047.035-.07l.07-.07 2.426-1.758.07-.07a.312.312 0 00.036-.141v-1.3-.071c.023-.024.035-.047.035-.07l.492-.704zm2.215-10.757l.07-.07c.024-.024.059-.036.106-.036h1.054c.047-.023.07-.047.07-.07l.036-.035-.211-.387a9.107 9.107 0 00-3.797.95.23.23 0 00-.105.105c-.024.023-.036.058-.036.105v.07l.387 1.09c0 .047.024.094.07.14a.312.312 0 00.141.036h.527a.409.409 0 00.07-.105l1.618-1.793zm8.156 12.304l3.305-3.55v-.036c-.094-1.875-.68-3.562-1.758-5.062a9.756 9.756 0 00-4.078-3.41h-.07c0-.024-.012-.035-.036-.035-.023 0-.046.011-.07.035h-.035l-1.266.738a.409.409 0 00-.07.105c-.023.024-.035.059-.035.106v.07l.527 2.074V6.344a.269.269 0 01-.035.105c0 .024-.023.047-.07.07l-2.04 1.723-.07.07v.176l.422 1.02a.412.412 0 00.07.105.312.312 0 00.141.035H13.477l1.3-.316a.27.27 0 01.106-.035l.07-.07.317-.598.07-.07a.312.312 0 01.14-.036h.07c.024 0 .048.012.071.036l.738.527.07.07H16.57c.024-.023.047-.035.07-.035l.212-.14.07-.07a.312.312 0 00.035-.141v-.036l-.316-1.16.035.035-.035-.035V7.54a.239.239 0 01.246-.246h1.09a.238.238 0 01.246.246l.035 1.23a.238.238 0 00.246.247l.703-.036h.035c.047 0 .094.024.14.07.048.048.071.106.071.177v.07l-.387.95a.23.23 0 01-.105.105.312.312 0 01-.14.035h-6.012a.27.27 0 00-.106.035c-.023 0-.047.012-.07.035l-1.406 1.336a.41.41 0 00-.07.105V12.04l.702 1.828.07.14a.312.312 0 00.141.036h1.723c.07 0 .117.012.14.035a.23.23 0 01.106.106l2.25 5.625c0 .046.023.082.07.105a.312.312 0 00.141.035h1.125a.23.23 0 00.105-.105l1.125-1.512c.024-.023.036-.047.036-.07v-.07-.036l-.387-2.742v-.035-.07l.07-.07z" fill="#051446"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.two.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.two.description') }}
              </p>
            </div>
          </div>
          <div class="flex md:w-1/3">
            <div class="flex-shrink-0 mr-3 -mt-1">
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.843 15.446l2.057-2.78a3.178 3.178 0 01-.867-.115 3.87 3.87 0 01-1.822-1.151H7.2v17.4h9V15.06l-1.741 2.355-2.616-1.969zm11.123-2.895a3.159 3.159 0 01-.866.116l2.057 2.78-2.616 1.968-1.741-2.354V28.8h9V11.4h-4.011a3.873 3.873 0 01-1.823 1.151z" fill="#05164D"/><path d="M22.618 15.117l-2.75-3.717-.184-.249c.288.09.587.176.885.249.489.13.99.201 1.496.216.207.004.414-.021.615-.074a2.903 2.903 0 001.458-4.585 2.87 2.87 0 00-.864-.731 2.835 2.835 0 00-2.178-.247C20.073 6.274 18.74 7.877 18 8.861c-.741-.984-2.073-2.586-3.096-2.882a2.836 2.836 0 00-2.178.247 2.872 2.872 0 00-1.377 1.738 2.903 2.903 0 001.969 3.578c.201.053.409.078.617.075a6.599 6.599 0 001.497-.217c.299-.073.597-.158.884-.249l-.184.249-2.75 3.717.96.709 3.058-4.137V28.8h1.2V11.69l3.06 4.136.958-.709zm-8.969-4.72a1.706 1.706 0 01-1.155-2.107 1.685 1.685 0 011.43-1.222c.218-.025.44-.006.65.056.537.155 1.527 1.232 2.32 2.252l-.001.002.181.243c-1.26.48-2.844.939-3.422.774l-.003.002zm9.048-3.129a1.685 1.685 0 01.809 1.022 1.706 1.706 0 01-1.155 2.106c-.577.165-2.161-.292-3.422-.774l.18-.244-.001-.003c.792-1.02 1.782-2.097 2.32-2.253a1.655 1.655 0 011.27.144l-.001.002z" fill="#05164D"/></svg>
            </div>
            <div class="leading-snug">
              <p class="pb-1 text-base font-bold md:pb-2 xl:text-2xl">
                {{ tr('pages.sales.landing.benefit.three.title') }}
              </p>
              <p class="text-sm leading-normal xl:text-base">
                {{ tr('pages.sales.landing.benefit.three.description') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-12 md:px-6 lg:px-8 xl:px-20 xl:mb-20 text-sn-gray-900">
      <div class="container">
        <h2 id="get-voucher" class="px-4 pb-4 text-xl font-bold md:pb-6 md:text-2xl md:px-0 xl:text-1.75xl">
          {{ tr('pages.sales.landing.types.title') }}
        </h2>
        <div class="flex px-4 py-4 overflow-x-auto md:justify-start md:overflow-x-visible md:py-0 md:px-0">
          <TypeCard
            :title="tr('pages.sales.landing.types.digital.title')"
            class="mr-6 xl:mr-14"
          >
            <template v-slot:image>
              <img
                srcset="~images/brussels/offers/digital-voucher@2x.jpg 2x, ~images/brussels/offers/digital-voucher.jpg 1x "
                src="~images/brussels/offers/digital-voucher.jpg"
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.digital.benefit') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="primary"
                :href="$i18nTo({ name: 'voucherSaleAmount' })"
              >
                {{ tr('pages.sales.landing.types.digital.button') }}
              </Button>
            </template>
          </TypeCard>

          <TypeCard :title="tr('pages.sales.landing.types.existing.title')">
            <template v-slot:image>
              <img
                srcset="~images/brussels/offers/digital-voucher-app@2x.jpg 2x, ~images/brussels/offers/digital-voucher-app.jpg 1x"
                src="~images/brussels/offers/digital-voucher-app.jpg"
              >
            </template>

            <p class="text-sm xl:text-base">
              {{ tr('pages.sales.landing.types.existing.description') }}
            </p>

            <template v-slot:buttons>
              <Button
                variant="secondary"
                :href="brusselsLink"
              >
                {{ tr('pages.sales.landing.types.existing.button.redeem') }}
              </Button>
            </template>
          </TypeCard>
        </div>
      </div>
    </div>
    <div class="container mb-12 xl:mb-20">
      <HowItWorks />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import HowItWorks from '~brand-components/brussels/sale-landing-page/how-it-works.vue'
import Button from '~brand-components/brussels/button/button.vue'
import TypeCard from '~brand-components/brussels/type-card/type-card.vue'

export default Vue.extend({
  components: {
    Button,
    HowItWorks,
    TypeCard,
  },
  computed: {
    brusselsLink(): string {
      if (this.$i18n.locale === 'fr') {
        return 'https://www.brusselsairlines.com/xx/fr'
      }

      if (this.$i18n.locale === 'nl') {
        return 'https://www.brusselsairlines.com/xx/nl'
      }

      return 'https://brusselsairlines.com'
    },
  },
})
</script>

<style lang="scss" scoped>
.hero {
  min-height: 490px;
  background: url("../../images/brussels/hero-sale/mobile-2.jpg") right top / cover no-repeat;

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    background-image: url("../../images/brussels/hero-sale/mobile-2@2x.jpg");
  }
}

@screen md {
  .hero {
    min-height: 530px;
    background: url("../../images/brussels/hero-sale/tablet-2.jpg") center center / cover no-repeat;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/brussels/hero-sale/tablet-2@2x.jpg");
    }
  }
}

@screen xl {
  .hero {
    background: url("../../images/brussels/hero-sale/desktop-2.jpg") center center / cover no-repeat;
    min-height: 530px;
    aspect-ratio: 1440 / 530;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url("../../images/brussels/hero-sale/desktop-2@2x.jpg");
    }
  }

}
</style>
